import { M_InputTextField } from '../../../../M_Components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

export const IdFieldItemForm = ({ field, changeValueCallback, itemForm, isDisabled }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    // Initialize UUID synchronously if not present
    const currentValue = itemForm.form[field.Code];
    if (!currentValue) {
        const newId = uuidv4();
        // Set value immediately, before first render
        setTimeout(() => {
            changeValueCallback({
                ...itemForm,
                form: {
                    ...itemForm.form,
                    [field.Code]: newId
                }
            });
        }, 0);
    }

    const handleInputChange = (value) => {
        changeValueCallback({
            ...itemForm,
            form: {
                ...itemForm.form,
                [field.Code]: value
            }
        });
    }

    return (
        <div className="text-small">
            {
                <M_InputTextField
                    label={field.Captions[currentLanguage]?.length > 0 ? field.Captions[currentLanguage] : field.Code}
                    value={itemForm.form[field.Code] || ""}
                    required={field.IsMandatory}
                    disabled={true}
                    onChange={(e) => handleInputChange(e.target.value)}
                />
            }
        </div>
    );
}
